module.exports = __webpack_public_path__ + "static/img/高铁to展馆.8b7d2e55.png";